/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'categorydropdown': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<path pid="0" d="M.123 1.927C.123 1.347.578.89 1.159.89c.29 0 .559.124.745.31L5.116 4.58 8.327 1.2a1.026 1.026 0 0 1 1.472-.02c.414.393.435 1.056.02 1.47L5.862 6.797a1.045 1.045 0 0 1-1.471.041c-.021 0-.021-.02-.042-.041L.371 2.652c-.166-.207-.27-.456-.248-.725z" _fill="#007FEA" fill-rule="nonzero"/>'
  }
})
